export default __webpack_public_path__ + "static/media/template_8.f9405a8f.png";